
const mc = [
    {
        "r": 1,
        "c": 0,
        "v": {
            "v":'标准',
            "bl": 1, 
            'ht':0
        },
        "mc": {      
            "r": 1,  
            "c": 0,  
            "rs": 7, 
            "cs": 1  
        },
        
    }, 
    {
        "r": 9,
        "c": 0,
        "v": {
            "v":'实际',
            'ht':0,
            "bl": 1, 
        },
        "mc": {       
            "r": 9,   
            "c": 0,   
            "rs": 12, 
            "cs": 1   
        },
        
    },
   
]
const merge = {
    "1_0": {
        "r": 1,
        "c": 0,
        "rs": 7,
        "cs": 1
    },
    "9_0": {
        "r": 9,
        "c": 0,
        "rs": 12,
        "cs": 1
    },
   
}
const firstHeader =[
    '类别','-','序号','科目名称','期初数','合计',
   
    
]

const indexOne = [
    '1','1.1','2','2.1','2.2','3','4','','1','1.1','1.2','2','2.1','2.2','2.3','3','4','与标准差异说明',''
]
const saleHeader = [
    '现金流入小计','销售收入','现金流出小计','当月货款支付','当月费用支付','当期净现金流量','累计净现金流量',
    '','现金流入小计','销售收入','其他调整项','现金流出小计','当月货款支付','当月费用支付',
    '其他调整项','当期净现金流量','累计净现金流量','现金流入调整说明','现金流出调整说明',
]
const border = [
    {
        "rangeType": "range",
        "borderType": "border-all",
        "style": "3",
        "color": "#a4a4a4",
        "range": [{
            "row": [0, 50],
            "column": [0, 23]
        }]
    },
]

export { mc,merge,firstHeader,indexOne, saleHeader,border }